import {PaymentModel} from "../payment.model";
import {ParamConfig} from "../../config-support/param-config.service";
import {
    PaymentAuthorisationType,
    WalletPaymentErrorType,
    WalletPaymentSubmissionFailure,
    WalletPaymentSubmissionResult,
    WalletProvider
} from "../payment";
import {WalletPaymentProcessor} from "./wallet-payment-processor";

export class StripeWalletPaymentProcessor extends WalletPaymentProcessor {
    private stripe: any;
    private stripePaymentRequest: any;

    constructor(paymentModel: PaymentModel) {
        super(paymentModel);
    }

    public async init(): Promise<WalletPaymentProcessor> {
        this.quickPayAvailable = false;
        if (!this.paymentModel.paymentPlatformPublicKey) {
            return undefined;
        }

        // noinspection JSUnresolvedReference
        try {
            this.stripe = new (<any>window).Stripe(this.paymentModel.paymentPlatformPublicKey);
            this.stripePaymentRequest = this.stripe.paymentRequest({
                country: "AU",
                currency: "aud",
                total: {
                    label: "Order total",
                    // payment value will be updated on submission
                    amount: 100
                },
                requestPayerName: this.paymentModel.requestPayerName || this.paymentModel.requestPayerPostcode, // Either way, it just requires billing details
                requestPayerEmail: this.paymentModel.requestPayerEmail,
                requestPayerPhone: this.paymentModel.requestPayerPhone
            });
        } catch (error) {
            console.error("Stripe wallet payment initialisation failed", error);
            return undefined;
        }

        const paramConfig: ParamConfig = await this.paymentModel.paramConfigService.getConfig();
        this.walletProvider = paramConfig.forcePay === "apple" ? WalletProvider.APPLE_PAY
            : paramConfig.forcePay === "google" ? WalletProvider.GOOGLE_PAY
                : undefined;
        if (this.walletProvider == undefined) {
            // noinspection JSUnresolvedReference
            const availability: any = await this.stripePaymentRequest.canMakePayment();

            // noinspection JSUnresolvedReference
            try {
                this.walletProvider = !availability ? undefined
                    : availability.applePay ? WalletProvider.APPLE_PAY
                        : availability.googlePay ? WalletProvider.GOOGLE_PAY
                            : undefined;
            } catch (error) {
                console.error("Failed to check wallet availability using Stripe", error);
            }
        }
        console.log("Wallet payment provider =", this.walletProvider);
        if (this.walletProvider == undefined) {
            return undefined;
        }
        this.quickPayAvailable = true;

        this.stripePaymentRequest.on("paymentmethod", (paymentResponse: any) => {
            paymentResponse.complete("success");
            this.paymentModel.analyticsService.trackWalletPaymentRequestSucceeded(this.walletProvider);
            this.resolveSubmission(new WalletPaymentSubmissionResult(PaymentAuthorisationType.STRIPE_PAYMENT_METHOD, paymentResponse.paymentMethod.id,
                paymentResponse.payerName, paymentResponse.payerEmail, paymentResponse.payerPhone, paymentResponse.paymentMethod.billing_details.address.postal_code));
            this.rejectSubmission = undefined;
            this.resolveSubmission = undefined;
        });

        // noinspection JSUnusedLocalSymbols
        this.stripePaymentRequest.on("cancel", (paymentResponse: any) => {
            this.paymentModel.analyticsService.trackWalletPaymentRequestCancelled(this.walletProvider);
            this.rejectSubmission(new WalletPaymentSubmissionFailure(this.walletProvider === WalletProvider.APPLE_PAY ? WalletPaymentErrorType.APPLE_PAY_CANCELLED : WalletPaymentErrorType.GOOGLE_PAY_CANCELLED));
            this.rejectSubmission = undefined;
            this.resolveSubmission = undefined;
        });
        return this;
    }

    public async submit(amount: number): Promise<WalletPaymentSubmissionResult> {
        // noinspection ES6MissingAwait
        this.paymentModel.analyticsService.trackWalletPaymentRequestStarted(this.walletProvider);

        if (this.resolveSubmission) {
            this.rejectSubmission(new WalletPaymentSubmissionFailure(WalletPaymentErrorType.INVALID_STATE));
            await this.init();
        }

        this.stripePaymentRequest.update({
            total: {
                label: "Order total" + (this.paymentModel.paymentPlatformPublicKey.startsWith("pk_test") ? "(Test)" : ""),
                amount: Math.round(amount * 100),
            }
        });
        return new Promise<WalletPaymentSubmissionResult>((resolve: (value?: WalletPaymentSubmissionResult | PromiseLike<WalletPaymentSubmissionResult>) => void, reject: (reason?: any) => void) => {
            this.resolveSubmission = resolve;
            this.rejectSubmission = reject;
            this.stripePaymentRequest.show();
        });
    }
}


// WEBPACK FOOTER //
// ./src/app/payment/wallet-payment/stripe-wallet-payment-processor.ts